"use strict";

import React from "react";
import { Row, Col } from "react-bootstrap";
import { Joi, Validation } from "react-validation-decorator";

class ContactForm extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      subject: "",
      body: ""
    };
    this._handleInputChange = this._handleInputChange.bind(this);
  }

  validationSchema = Joi.object().keys({
    email: Joi.string()
      .email()
      .lowercase()
      .required()
      .label("email"),
    subject: Joi.string()
      .required()
      .label("subject"),
    body: Joi.string()
      .required()
      .label("body")
  });

  componentWillMount() {
    if(this.props.mentorEmail) {
      this.setState({ email: this.props.mentorEmail })
    }
  }

  componentWillReceiveProps(newProps) {
    if(newProps.mentorEmail != this.props.mentorEmail) {
      this.setState({ mentorEmail: newProps.mentorEmail });
    }
  }

  render() {
    return (
      <form name="ContactForm" noValidate>
      <Row>
        <Col md={12}>
          <p>Write your question below, or you can contact Prof. Rohit Aggarwal at rohit.aggarwal@eccles.utah.edu / 860-303-4742.</p>
        </Col>
      </Row>
        <Row>
          <Col md={12}>
            <div className={this.getValidationClassName("email")}>
              <label>From:</label>
              <input
                type="email"
                className="form-control"
                value={this.state.email}
                placeholder="Enter your Email"
                onChange={this._handleInputChange.bind(this, "email")}
              />
              {this.renderValidationMessages("email")}
            </div>
          </Col>
          {/* <Col md={12}>
            <div>
              <label>To:</label>
              <h4>rohit103@gmail.com</h4>
            </div>
          </Col> */}
          <Col md={12}>
            <div className={this.getValidationClassName("subject")}>
              <label>Subject</label>
              <input
                type="text"
                className="form-control"
                value={this.state.subject}
                placeholder="Enter the subject"
                onChange={this._handleInputChange.bind(this, "subject")}
              />
              {this.renderValidationMessages("subject")}
            </div>
          </Col>

          <Col md={12}>
            <div className={this.getValidationClassName("body")}>
              <label>Question</label>
              <textarea
                className="form-control"
                value={this.state.body}
                placeholder="Your Question"
                onChange={this._handleInputChange.bind(this, "body")}
              />
              {this.renderValidationMessages("body")}
            </div>
          </Col>
        </Row>
      </form>
    );
  }

  _handleInputChange(formInput, event) {
    let value = event.target.value;
    this.setState(
      state => {
        state[formInput] = value;
      },
      () => {
        this.validate(formInput);
        this._isFormValid();
      }
    );
  }

  _isFormValid() {
    this.props.isValid(!this.state.validation.errors.length);
  }

  getModel() {
    return this.state.validation.value;
  }
}

export default Validation(ContactForm);
